"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["dataQa", "onClick"];
var Window = typeof window !== 'undefined' ? window : {};

var TrackingWrapper = function TrackingWrapper(Component, eventName) {
  return function (_ref) {
    var dataQa = _ref.dataQa,
        onClick = _ref.onClick,
        props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var _props$cta = props.cta,
        cta = _props$cta === void 0 ? {} : _props$cta;

    var clickHandler = function clickHandler(event, value) {
      if (Window.analytics) {
        cta.element = dataQa;
        Window.analytics.track(eventName, {
          cta: cta
        });
      }

      if (onClick) {
        return onClick(event, value);
      }
    };

    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      dataQa: dataQa,
      onClick: clickHandler
    }, props));
  };
};

TrackingWrapper.propTypes = {
  Component: _propTypes["default"].element.isRequired,
  eventName: _propTypes["default"].string.isRequired
};
var _default = TrackingWrapper;
exports["default"] = _default;